import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SuperadminDashboardComponent } from './superadmin-dashboard/superadmin-dashboard.component';
import { StateadminComponent } from './superadmin-dashboard/stateadmin/stateadmin.component';
import { DistrictadminComponent } from './superadmin-dashboard/districtadmin/districtadmin.component';
import { AppOrRejComponent } from './superadmin-dashboard/app-or-rej/app-or-rej.component';
import { MeetingsComponent } from './superadmin-dashboard/meetings/meetings.component';
import { ReportsComponent } from './superadmin-dashboard/reports/reports.component';
import { SignOutComponent } from './superadmin-dashboard/sign-out/sign-out.component';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './superadmin-dashboard/dashboard/dashboard.component';
import { StateadminMenuComponent } from './stateadmin-menu/stateadmin-menu.component';
import { DistrictadminMenuComponent } from './districtadmin-menu/districtadmin-menu.component';
import { DaDashboardComponent } from './districtadmin-menu/da-dashboard/da-dashboard.component';
import { AppointDistrictOffBearerComponent } from './districtadmin-menu/appoint-district-off-bearer/appoint-district-off-bearer.component';
import { ReqOffBearerChangeComponent } from './districtadmin-menu/req-off-bearer-change/req-off-bearer-change.component';
import { SelfRegistrationComponent } from './self-registration/self-registration.component';
import { CreateOffBearerComponent } from './districtadmin-menu/create-off-bearer/create-off-bearer.component';
import {FormsModule,ReactiveFormsModule } from '@angular/forms';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { OfficeBearerApprovalComponent } from './superadmin-dashboard/office-bearer-approval/office-bearer-approval.component';
import { HttpClientModule } from '@angular/common/http';
import { DataTablesModule } from 'angular-datatables';
import {CreateMeetingsComponent} from 'src/app/stateadmin-menu/create-meetings/create-meetings.component';
import { ChangePasswordComponent } from './change-password/change-password.component'
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { DaMeetingComponent } from './districtadmin-menu/da-meeting/da-meeting.component';
import { SADashboardComponent } from './stateadmin-menu/sa-dashboard/sa-dashboard.component';
import { AddtionalPostReqApprovalComponent } from './superadmin-dashboard/addtional-post-req-approval/addtional-post-req-approval.component';
import { MenuChangePasswordComponent } from './menu-change-password/menu-change-password.component';
import { DaReportComponent } from './superadmin-dashboard/da-report/da-report.component';
import { ObLoginComponent } from './ob-login/ob-login.component';
import { ObReportComponent } from './superadmin-dashboard/ob-report/ob-report.component';
import { ProfileDetailsComponent } from './profile-details/profile-details.component';
import { DaAddressreportComponent } from './da-addressreport/da-addressreport.component';
import { ZoneReportComponent } from './superadmin-dashboard/zone-report/zone-report.component';
import { ObDashboardComponent } from './ob-login/ob-dashboard/ob-dashboard.component';
import { Kalaignar100Component } from './kalaignar100/kalaignar100.component';
import { Kalaignar100ReportComponent } from './kalaignar100-report/kalaignar100-report.component';
import { ActivityComponent } from './superadmin-dashboard/activity/activity.component';
import { CourseComponent } from './superadmin-dashboard/course/course.component';
import { CourseDistrictComponent } from './districtadmin-menu/course-district/course-district.component';
import { ActivitySummaryComponent } from './superadmin-dashboard/activity-summary/activity-summary.component';
import { StudentRegisterComponent } from './superadmin-dashboard/student-register/student-register.component';
import { MentorComponent } from './superadmin-dashboard/mentor/mentor.component';
import { StudentDashboardComponent } from './student-dashboard/student-dashboard.component';
import { DashboardComponent as StuDashboard } from './student-dashboard/dashboard/dashboard.component';
import { MentorDashboardComponent } from './mentor-dashboard/mentor-dashboard.component';
import { DashboardComponent as MenDashboard } from './mentor-dashboard/dashboard/dashboard.component';
import { CourseComponent as StCourseComponent } from './student-dashboard/course/course.component';
import { MentorSessionComponent } from './mentor-dashboard/mentor-session/mentor-session.component';
import { StudentIndexComponent } from './superadmin-dashboard/student-index/student-index.component';
import { MentorIndexComponent } from './superadmin-dashboard/mentor-index/mentor-index.component';
import { StudentChangePasswordComponent } from './student-dashboard/student-change-password/student-change-password.component';
import { MentorChangepasswordComponent } from './mentor-dashboard/mentor-changepassword/mentor-changepassword.component';
import { DastudentlistComponent } from './districtadmin-menu/dastudentlist/dastudentlist.component';
import { DaMentorlistComponent } from './districtadmin-menu/da-mentorlist/da-mentorlist.component';
import { CourseAssignedComponent } from './mentor-dashboard/course-assigned/course-assigned.component';
import { StdashboardComponent } from './student-dashboard/stdashboard/stdashboard.component';
import { StudentFeedbackComponent } from './student-dashboard/student-feedback/student-feedback.component';
import { MentorFeedbackComponent } from './mentor-dashboard/mentor-feedback/mentor-feedback.component';
import { CourseAttendanceComponent } from './districtadmin-menu/course-attendance/course-attendance.component';
import { VolunteerSessionComponent } from './districtadmin-menu/volunteer-session/volunteer-session.component';
import { DaStudentFeedbackComponent } from './districtadmin-menu/da-student-feedback/da-student-feedback.component';
import { DaMentorFeedbackComponent } from './districtadmin-menu/da-mentor-feedback/da-mentor-feedback.component';
import { MtdashboardComponent } from './mentor-dashboard/mtdashboard/mtdashboard.component';
import { SuperCourseAttendanceComponent } from './superadmin-dashboard/super-course-attendance/super-course-attendance.component';
import { MentorstudentrequestComponent } from './mentorstudentrequest/mentorstudentrequest.component';
import { MentorlistComponent } from './mentorlist/mentorlist.component';
import { MentorStudentCourseComponent } from './student-dashboard/mentor-student-course/mentor-student-course.component';
import { StudentCourseComponent } from './student-dashboard/student-course/student-course.component';
import { MentorstudentgrouprequestComponent } from './mentorstudentgrouprequest/mentorstudentgrouprequest.component';

import { StudentEnrollComponent } from './mentor-dashboard/student-enroll/student-enroll.component';
import { StudentRequestListComponent } from './student-dashboard/student-request-list/student-request-list.component';
import { StudentGroupRequestListComponent } from './student-dashboard/student-group-request-list/student-group-request-list.component';



import { MentorVolunteerComponent } from './mentor-dashboard/mentor-volunteer/mentor-volunteer.component';
import { DaMentorVolunteerComponent } from './districtadmin-menu/da-mentor-volunteer/da-mentor-volunteer.component';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { VerifyOtpComponent } from './verify-otp/verify-otp.component';
import { MentorCreateCourseListComponent } from './superadmin-dashboard/mentor-create-course-list/mentor-create-course-list.component';




@NgModule({
  declarations: [
    AppComponent,
    SuperadminDashboardComponent,
    StateadminComponent,
    DistrictadminComponent,
    AppOrRejComponent,
    MeetingsComponent,
    ReportsComponent,
    SignOutComponent,
    LoginComponent,
    DashboardComponent,
    StateadminMenuComponent,
    DistrictadminMenuComponent,
    DaDashboardComponent,
    AppointDistrictOffBearerComponent,
    ReqOffBearerChangeComponent,
    SelfRegistrationComponent,
    CreateOffBearerComponent,
    ForgotPasswordComponent,
    OfficeBearerApprovalComponent,
    CreateMeetingsComponent,
    AppointDistrictOffBearerComponent,
    ChangePasswordComponent,
    MeetingsComponent,
    CreateMeetingsComponent,
    DaMeetingComponent,
    SADashboardComponent,
    AddtionalPostReqApprovalComponent,
    MenuChangePasswordComponent,
    DaReportComponent,
    ObLoginComponent,
    ObReportComponent,
    ProfileDetailsComponent,
    DaAddressreportComponent,
    ZoneReportComponent,
    ObDashboardComponent,
    Kalaignar100Component,
    Kalaignar100ReportComponent,
    ActivityComponent,
    CourseComponent,
    CourseDistrictComponent,
    ActivitySummaryComponent,
    StudentRegisterComponent,
    MentorComponent,
    StudentDashboardComponent,
    MentorDashboardComponent,
    StCourseComponent,
    MentorSessionComponent,
    StudentIndexComponent,
    MentorIndexComponent,
    StudentChangePasswordComponent,
    MentorChangepasswordComponent,
    DastudentlistComponent,
    DaMentorlistComponent,
    CourseAssignedComponent,
    StdashboardComponent,
    StudentFeedbackComponent,
    MentorFeedbackComponent,
    CourseAttendanceComponent,
    VolunteerSessionComponent,
    DaStudentFeedbackComponent,
    DaMentorFeedbackComponent,
    StuDashboard,
    MenDashboard,
    MtdashboardComponent,
    SuperCourseAttendanceComponent,
    MentorstudentrequestComponent,
    MentorlistComponent,
    MentorStudentCourseComponent,
    StudentCourseComponent,
    MentorstudentgrouprequestComponent,
    StudentEnrollComponent,
    StudentRequestListComponent,
    StudentGroupRequestListComponent,
    MentorstudentrequestComponent,
    MentorVolunteerComponent,
    DaMentorVolunteerComponent,
    VerifyOtpComponent,
    MentorCreateCourseListComponent,


    
    ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,ReactiveFormsModule, 
    HttpClientModule,DataTablesModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    NgMultiSelectDropDownModule.forRoot(),BrowserAnimationsModule,NgxSpinnerModule
  ],
  
  
  // providers: [],
  providers: [DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
